import { Typography } from '@material-ui/core';
import { ColDef } from '@material-ui/data-grid';
import { useEffect, useState } from 'react'
import DataTable from '../../components/DataTable';
import api from '../../config/api'
import { Container } from './styles'
import { useHistory } from 'react-router-dom'
import Loading from '../../components/Loading';
import { truncate } from 'fs';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

interface Branch {
    id: number
    description: string
    store_status: string
    created_at: string
}

function Stocks() {

    const [loading, setLoading] = useState(false)
    const [branchs, setBranchs] = useState<Branch[]>([])
    const [updatedBranch, setUpdateBranchs] = useState<Branch[]>([])
    let history = useHistory();


    useEffect(() => {
        setLoading(true)
        async function fetch() {
            const response = await api.get('/branchs')
            setBranchs(response.data.branchs)
            setUpdateBranchs(response.data.branchs)
            setLoading(false)
        }
        fetch()
    }, [])

    async function setInfo() {
        setLoading(true)
        async function fetch() {
            const response = await api.get('/branchs')
            setBranchs(response.data.branchs)
            branchs.forEach(element => {
                element.store_status = 'Ativo'
            });
        }
        fetch()
        setUpdateBranchs(branchs)
        console.log(branchs)
        setLoading(false)
    }



    function handleClick(row: any) {
        console.log(branchs)
        const { id } = row.data
        const { description } = row.data
        history.push(`/stocks/${id}`, { city: description })
        // history.push(`/products`, { city: description })
    }

    const columns: ColDef[] = [
        { field: 'id', headerName: 'ID', width: 100 },
        { field: 'description', headerName: 'Nome', width: 300 },
        { field: 'store_status', headerName: 'Status - Sicredi Store', width: 300 }
    ];

    return (
        <>
            <Container>
                {
                    loading ?
                        <Loading />
                        :
                            <>
                                <Button
                                    onClick={setInfo}
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    children="Obter Status do Sicredi Store"
                                ></Button>
                                <Typography variant="h4" style={{ marginBottom: 10, fontWeight: 600 }}>
                                    Escolha uma agência
                                </Typography>
                                <DataTable columns={columns} rows={updatedBranch} handleClick={handleClick} />
                            </>
                }
            </Container>
        </>
    );
}

export default Stocks